module.exports = __webpack_public_path__ + "static/suite-ldr-1-f61ea8580a9e7aed6e7a5730292c2e11.jpg";